import * as React from "react";
import appHistory from "../../AppHistory";
import { DateTimeFormatter } from "../../Shared/Util/DateTimeFormatter";
import { Tooltip } from "react-tooltip";

interface IResponseListRow {
  response: Api.IResponseListViewModel,
  isDraft?: boolean;
  iconClickCallback: () => void;
}

interface IResponseListRowState {
  isHovered: boolean;
}

class ResponseListRow extends React.Component<IResponseListRow, IResponseListRowState> {
  constructor(props: IResponseListRow) {
    super(props);

    this.state = { isHovered: false };
    this.handleRowClick = this.handleRowClick.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  public render() {
    if (!!this.props.isDraft) {
      return (
        <tr onClick={this.handleRowClick} onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
          <td>{this.props.response.referenceId}</td>
          <td className='title-link'>{this.props.response.title}</td>
          <td>{this.props.response.category}</td>
          <td>{DateTimeFormatter.ToShortDate(this.props.response.dateModified)}</td>
        </tr>
      )
    } else {
      return (
        <tr onClick={this.handleRowClick} onMouseEnter={this.handleMouseEnter
        } onMouseLeave={this.handleMouseLeave}>
          <td>{this.props.response.referenceId}</td>
          <td className='title-link'>{this.props.response.title}</td>
          <td>{DateTimeFormatter.ToShortDate(this.props.response.dateModified)}</td>
          <td>{this.props.response.updatedBy}</td>
          <td>{this.props.response.category}</td>
          <td className="panviva-id-column-data">{this.props.response.documentId}
            {this.state.isHovered && <img data-tooltip-id="version-history-tooltip" data-tooltip-content={"Version History"} src="/images/version-history.svg" alt="history-link-icon" onClick={(e) => { e.stopPropagation(); this.props.iconClickCallback(); }} />}
            <Tooltip
              id="version-history-tooltip"
              place={"bottom-start"}
              variant={"info"}
              className={"cc-tooltip"} />
          </td>
        </tr >
      )
    }
  }

  private handleRowClick(e: any) {
    let url = this.props.response.isExternalArtefact
      ? `/manage/${this.props.response.id}?isExternal=true`
      : `/manage/${this.props.response.id}?documentId=${this.props.response.documentId}`;

    if (!!this.props.isDraft) {
      url = `${url}&isDraft=true`;
    }
    appHistory.push(url);
  }

  private handleMouseEnter() {
    this.setState({ isHovered: true });
  }

  private handleMouseLeave() {
    this.setState({ isHovered: false });
  }
}

export { ResponseListRow };
